<template>
  <div class="my-14 fruit-slider">
    <div class="relative">
      <slick-carousel v-bind="settings">
        <div class="homepage__fruit" v-for="(fruit, i) in fruits" :key="i">
          <div class="relative">
            <img
              class="homepage__fruit__shadow"
              :draggable="false"
              :class="
                selectedFruit.id == fruit.id
                  ? 'homepage__fruit__shadow--active'
                  : ''
              "
              :src="require('@/assets/images/shadow.png')"
              alt=""
            />
            <img
              @click="$emit('selectFruitHandler', fruit)"
              :draggable="false"
              class="homepage__fruit__img"
              :src="require(`@/assets/images/colors/${fruit.img}`)"
            />
            <!-- <span class="white--text">{{ fruit.title }}</span> -->
          </div>
        </div>
        <template #prevArrow>
          <img :src="require('@/assets/images/arrow-left.svg')" />
        </template>
        <template #nextArrow>
          <img :src="require('@/assets/images/arrow-right.svg')" />
        </template>
      </slick-carousel>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fruits: {
      type: Array,
      default: () => [],
    },
    selectedFruit: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    settings: {
      arrows: true,
      dots: false,
      infinite: true,
      margin: 20,
      slidesToShow: 10,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 960,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
          },
        },
      ],
    },
  }),
};
</script>

<style></style>
